// frontend-react/src/components/sales/ProductSelector.jsx
import React, { memo } from 'react';

function fmtXof(n) {
  return Number(n || 0).toLocaleString('fr-FR');
}

function availableStock(p) {
  return Number(p?.stock_quantity ?? p?.stock ?? 0);
}

export default memo(function ProductSelector({
  products,
  pid,
  setPid,
  qty,
  setQty,
  variantsLoading,
  onAddLine,
}) {
  const selectedProduct = products.find(p => p.id === pid);

  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-2">
      <select
        value={pid}
        onChange={e => setPid(e.target.value)}
        className="border px-2 py-2 rounded-lg col-span-2 bg-surface-card"
      >
        <option value="">-- choisir produit --</option>
        {products.map(p => {
          const remain = availableStock(p);
          return (
            <option key={p.id} value={p.id}>
              {p.name} - {remain} en stock
            </option>
          );
        })}
      </select>

      <input
        type="number"
        value={qty}
        min={1}
        onChange={e => setQty(Number(e.target.value))}
        className="border px-2 py-2 rounded-lg"
      />

      <div className="flex items-center text-sm text-content-primary">
        {selectedProduct ? (
          variantsLoading ? (
            'Chargement variants...'
          ) : (
            `PU base: ${fmtXof(selectedProduct?.unit_price ?? 0)} XOF`
          )
        ) : (
          'PU base: -'
        )}
      </div>

      <button onClick={onAddLine} className="px-3 py-2 bg-green-600 text-white rounded-lg">
        Ajouter
      </button>
    </div>
  );
});
